import { Navigate } from 'react-router-dom';

const Admins = () => <Navigate to="/doctors" replace />;

export default Admins;
